import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

export const addAgreementData = async (data) => {
  const response = await gatewayInstance.post(
    `${SERVICE_ENDPOINT.TRANSPORT}/agreement`,
    data,
  );
  return response.data;
};

export const updateAgreementData = async (data) => {
  const response = await gatewayInstance.put(
    `${SERVICE_ENDPOINT.TRANSPORT}/agreement`,
    data,
  );
  return response.data;
};

export const getAgreementData = async () => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/agreement`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
    // Handle the error as needed (logging, showing an error message, etc.)
    throw e; // Re-throw the error to propagate it to the caller
  }
};

export const getAgreementDataById = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/agreement/${id}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
    // Handle the error as needed (logging, showing an error message, etc.)
    throw e; // Re-throw the error to propagate it to the caller
  }
};

export const getAgreementSearchData = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/agreement/search`,
      data,
    );
    return response.data;
  } catch (e) {
    console.error(e);
    // Handle the error as needed (logging, showing an error message, etc.)
    throw e; // Re-throw the error to propagate it to the caller
  }
};


export const canSelectAgrReference = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/agreement/reference/${id}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
    // Handle the error as needed (logging, showing an error message, etc.)
    throw e; // Re-throw the error to propagate it to the caller
  }
};
